export const LANDING = '/';
export const HOME = '/home';
